import dayjs from 'dayjs';
import { UAParser } from 'ua-parser-js';
import StackTrace from 'stacktrace-js';
import AWSCloudWatchLog from '@app/error/AWSCloudWatch';
import { ep } from '@app/endpoint';

const isAWSLoggerEnabled = !process.env.IS_DEV_MODE && !['DEV', 'LOCAL'].includes(ep.name);

export const logError = isAWSLoggerEnabled
  ? error => {
      const AWSCloudWatch = new AWSCloudWatchLog({
        region: 'us-east-1', // US East - N. Virginia
        accessKeyId: window.atob(process.env.AWS_ACCESS_KEY_ID || ''),
        secretAccessKey: window.atob(process.env.AWS_SECRET_ACCESS_KEY || ''), // log user access is restricted
        logStreamName: 'QAU-' + ep.name,
        logGroupName: 'QAU',
      });

      (typeof error !== 'string'
        ? StackTrace.fromError(error)
        : StackTrace.generateArtificially({
            filter: frame => !!frame.functionName,
          })
      )
        .then(stacktrace => {
          AWSCloudWatch.log({
            sid: process.env.SID,
            buildVersion: process.env.BUILD_VERSION,
            endpoint: ep.name,
            browserInfo: new UAParser().getResult(),
            errorMessage: error.message,
            url: document.location.href,
            metrics: {
              clientErrorTime: dayjs().valueOf(),
            },
            stacktrace,
          });
        })
        .catch(console.error);
    }
  : console.error;
